
interface MeetPodSectionProps {
  title?: string;
  description?: string[];
  image?: string;
}

export function MeetPodSection({
  title = "Meet the Pod 🎙️",
  description = [
    "Located in the heart of Travis Heights, right off South Congress, our backyard podcast studio offers a private and convenient spot for your recording needs.",
    "With plenty of free street parking available, you won't have to circle the block endlessly.",
    "Plus, you're just minutes from all the iconic food, coffee spots, and energy that South Congress has to offer. Come for the recording, stay for the vibe!"
  ],
  image = "/lovable-uploads/a7583f7e-6b99-407b-a3fb-463f6f9034b8.png"
}: MeetPodSectionProps) {
  return (
    <section className="py-20 bg-studio-mist">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <div className="space-y-6">
            <h2 className="text-4xl font-bold text-studio-stone">{title}</h2>
            <div className="space-y-4 text-lg text-studio-stone/80">
              {description.map((paragraph, index) => (
                <p key={index}>{paragraph}</p>
              ))}
            </div>
          </div>
          <div className="rounded-2xl overflow-hidden shadow-xl">
            <img 
              src={image}
              alt="Backyard podcast studio exterior"
              className="w-full h-[400px] object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
